import { ModalRef, useEntityBaseMetadata, useModuleBaseMetadata } from '@msdk/common'
import { EntityMetadata } from '@msdk/definitions'
import React, { useEffect } from 'react'

import { useI18nContext } from '../../providers'

interface Props {
  entityName: string
  moduleName: string
  modalRef?: ModalRef
  children: React.ReactElement
}

export function I18nWrapper(props: Props) {
  const entityBaseMetadata = useEntityBaseMetadata(props.entityName) as EntityMetadata
  const moduleBaseMetadata = useModuleBaseMetadata(props.entityName, props.moduleName) as EntityMetadata
  const { load } = useI18nContext()

  useEffect(() => {
    load(moduleBaseMetadata, entityBaseMetadata, props.moduleName)
  }, [])
  const children = React.cloneElement(props.children, { ...props.children.props, modalRef: props.modalRef })
  return <>{children}</>
}
